<template>
	<v-app id="inspire">
		<!--		<v-main>-->
		<router-view />
		<!--        </v-main>-->

		<dashboard-core-footer />
	</v-app>
</template>

<script>
	import DashboardCoreFooter from "src/layout/core/Footer";
	export default {
		name: "app",
		components: {
			DashboardCoreFooter,
		},
	};
</script>
